module.exports = __webpack_public_path__ + "img/map-icon.960a7d77.svg";